'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useCart } from '../hooks/useCart';
import { useDecisions } from '../hooks/useDecisions';
import { useLoyaltyContext } from '../hooks/useLoyaltyContext';
import { usePageLayout } from '../hooks/usePageLayout';
import { useConsentCategory } from '../scripts/hooks/useConsentCategory';
import { buildExtras, buildPetsmartMedalliaContextFromCartUI } from './buildPetsmartMedalliaContext';
import { useGetActiveOptimizelyCampaigns } from './useGetActiveOptimizelyCampaigns';
export function MedalliaCartSync() {
  const $ = _c(9);
  const {
    cart
  } = useCart();
  const {
    memberPoints
  } = useLoyaltyContext();
  const {
    user,
    userData
  } = usePageLayout();
  const hasC0002 = useConsentCategory("C0002");
  const ffMedalliaCustom = useDecisions("medallia_custom");
  const lastPublishedRef = useRef(null);
  const optimizelyCampaigns = useGetActiveOptimizelyCampaigns(hasC0002);
  let t0;
  let t1;
  if ($[0] !== cart || $[1] !== ffMedalliaCustom || $[2] !== hasC0002 || $[3] !== memberPoints || $[4] !== optimizelyCampaigns || $[5] !== user || $[6] !== userData) {
    t0 = () => {
      if (!hasC0002 || !ffMedalliaCustom || !cart) {
        delete window.petsmartMedalliaContext;
        lastPublishedRef.current = null;
        return;
      }
      const extras = buildExtras({
        user,
        userData,
        memberPoints,
        optimizelyCampaigns
      });
      const next = buildPetsmartMedalliaContextFromCartUI(cart, extras);
      const nextSerialized = JSON.stringify(next);
      window.petsmartMedalliaContext = next;
      if (nextSerialized === lastPublishedRef.current) {
        return _temp;
      }
      const notify = () => {
        if (window.KAMPYLE_ONSITE_SDK) {
          lastPublishedRef.current = nextSerialized;
          window.KAMPYLE_ONSITE_SDK.updatePageView();
        }
      };
      if (window.KAMPYLE_ONSITE_SDK) {
        notify();
        return _temp2;
      }
      window.addEventListener("neb_OnsiteLoaded", notify, {
        once: true
      });
      return () => {
        window.removeEventListener("neb_OnsiteLoaded", notify);
        delete window.petsmartMedalliaContext;
      };
    };
    t1 = [cart, hasC0002, ffMedalliaCustom, user, userData, memberPoints, optimizelyCampaigns];
    $[0] = cart;
    $[1] = ffMedalliaCustom;
    $[2] = hasC0002;
    $[3] = memberPoints;
    $[4] = optimizelyCampaigns;
    $[5] = user;
    $[6] = userData;
    $[7] = t0;
    $[8] = t1;
  } else {
    t0 = $[7];
    t1 = $[8];
  }
  useEffect(t0, t1);
  return null;
}
function _temp2() {
  delete window.petsmartMedalliaContext;
}
function _temp() {
  delete window.petsmartMedalliaContext;
}